import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  onBeforeNavigate?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  onBeforeNavigate,
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={e => {
    if (onClick) {
      onClick();
    } else if (href) {
      if (onBeforeNavigate) {
        onBeforeNavigate();
      }
      window.open(href, '_blank');
    } else {
      const target = document.getElementById('oferta');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }} className={`bg-rosegold text-cream font-sans font-medium tracking-wide py-4 px-8 rounded-sm shadow-lg hover:shadow-xl transition-shadow duration-300 uppercase text-sm md:text-base ${className}`} data-id="element-12">
      {children}
    </motion.button>;
}